import { R as React } from './injectIntl-6b03af4d.js';
import { u as useIntl } from './useIntl-dfb28031.js';
import { A as ApProgressSpinnerReact } from './ap-progress-spinner.react-4b9c679b.js';
import { A as ApTooltipReact } from './ap-tooltip.react-64a190bd.js';
import { s as styled } from './styled-a7735015.js';
import { C as Chip } from './Chip-2fae7ac0.js';

/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const StyledChip = styled(Chip, { shouldForwardProp: (prop) => prop !== 'error' })(({ error, theme, }) => (Object.assign({ backgroundColor: theme.palette.semantic.colorBackgroundGray, 
    // A large number so it's a circular pill-like chip
    borderRadius: '1000px', boxSizing: 'border-box', color: theme.palette.semantic.colorForeground, fontWeight: theme.typography.fontWeightRegular, gap: theme.spacing(1), height: '32px', outline: 'none', paddingLeft: theme.spacing(2), paddingRight: theme.spacing(2), cursor: 'default', '.MuiChip-label': { padding: 0 }, '.MuiChip-deleteIcon': {
        margin: 0,
        color: 'inherit',
        '&:hover': { color: 'inherit' },
    }, ':hover': { backgroundColor: theme.palette.semantic.colorHover }, ':focus-visible:not(.Mui-disable)': {
        backgroundColor: theme.palette.semantic.colorBackgroundGray,
        outline: `2px solid ${theme.palette.semantic.colorFocusIndicator}`,
        outlineOffset: '2px',
    }, '&.Mui-disabled': {
        outline: 'none !important',
        backgroundColor: theme.palette.semantic.colorBackgroundDisabled,
        color: theme.palette.semantic.colorForegroundLight,
        opacity: 1,
    } }, (error &&
    {
        backgroundColor: `${theme.palette.semantic.colorErrorBackground} !important`,
        color: `${theme.palette.semantic.colorForeground} !important`,
        fontWeight: theme.typography.fontWeightRegular,
        ':after': {
            content: `''`,
            borderRadius: 'inherit',
            position: 'absolute',
            inset: `0px`,
            boxSizing: 'border-box',
            border: `1px solid ${theme.palette.semantic.colorErrorText}`,
            pointerEvents: 'none',
        },
    }))));
const ApChipReact = (props) => {
    const { loading, disabled, tooltip, debugForceOpen = false, className } = props, restProps = __rest(props, ["loading", "disabled", "tooltip", "debugForceOpen", "className"]);
    const { formatMessage: translate } = useIntl();
    const shouldDisable = disabled || loading;
    const chip = (React.createElement(StyledChip, Object.assign({}, restProps, { deleteIcon: loading ? (React.createElement(ApProgressSpinnerReact, { size: "s", color: "inherit" })) : (React.createElement("portal-icon", { name: 'close', "aria-label": translate({ id: 'close-button' }) })), disabled: shouldDisable }, (shouldDisable && { 'tabIndex': -1 }))));
    if (tooltip && tooltip.length > 0) {
        return React.createElement(ApTooltipReact, { placement: 'top', content: tooltip, dontUseInternalOnlyDebugForceOpen: debugForceOpen, "aria-disabled": shouldDisable }, chip);
    }
    return chip;
};

export { ApChipReact as A };

//# sourceMappingURL=ap-chip.react-e07ce591.js.map